import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row } from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import { post } from "../../../helpers/api_helper";
import { Spin } from "antd";

import {
  successMessage,
  errorMessage,
  capitalizeString,
} from "../CommonFunctions";
import {
  POST_InventoryItemsInsert,
  POST_InventoryItemsUpdate,
  POST_GetInventoryItemsDetailByID,
  POST_GetCategoryDropDownListByCategoryType,
  POST_GetItemTypeDDLList,
} from "../../../helpers/url_helper";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomTextArea from "../../../CustomControls/CustomTextArea";

const AddInventoryItems = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();
  const [unitOptions, setUnitOptions] = useState([]);
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const [itemTypeOptions, setItemTypeOptions] = useState([]);

  // const itemTypeOptions = [
  //   { label: "Non-Consumable", value: 1 },
  //   { label: "Consumable", value: 2 },
  //   { label: "Machine Accessories", value: 3 },
  // ];

  const validationSchema = Yup.object().shape({
    ItemName: Yup.string().trim().required("Item Name is required field"),
    ItemCode: Yup.string().required("Item Code is required field"),
    ItemType: Yup.string().trim().required("Item Type is required field"),
    UnitID: Yup.string().trim().required("Unit is required field"),
    // TotalUnitQty: Yup.string()
    //   .trim()
    //   .required("Total Unit Qty is required field"),
    // TotalAvailableUnitQty: Yup.string()
    //   .trim()
    //   .required("Total Available Unit Qty is required field"),
  });

  useEffect(() => {
    getUnitDDL();
    getItemTypeDDL();
    if (PrimaryIdParam) {
      getInventoryItemsDetailsByID();
    }
  }, []);

  const getUnitDDL = () => {
    setIsLoading(true);
    post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 8, // Unit
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setUnitOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getItemTypeDDL = () => {
    setIsLoading(true);
    post(POST_GetItemTypeDDLList, {})
      .then((response) => {
        if (response?.IsSuccess) {
          setItemTypeOptions(
            response?.List?.map((item) => ({
              label: item?.ItemTypeName,
              value: item?.ItemType,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getInventoryItemsDetailsByID = () => {
    setIsLoading(true);
    post(POST_GetInventoryItemsDetailByID, {
      InventoryItemIDEncrypted: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
            TotalConsumptionUnitQty:
              response?.TotalConsumptionUnitQty == 0
                ? ""
                : response?.TotalConsumptionUnitQty,
            TotalAvailableConsumptionUnitQty:
              response?.TotalAvailableConsumptionUnitQty == 0
                ? ""
                : response?.TotalAvailableConsumptionUnitQty,
            OneUnitEqualToConsumptionUnit:
              response?.OneUnitEqualToConsumptionUnit == 0
                ? ""
                : response?.OneUnitEqualToConsumptionUnit,
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      InventoryItemIDEncrypted: PrimaryIdParam
        ? window.atob(PrimaryIdParam)
        : "",
      ItemName: "",
      ItemCode: "",
      ItemType: "",
      Description: "",
      UnitID: "",
      //TotalUnitQty: "",
      //TotalAvailableUnitQty: "",
      IsConsumable: false,
      ConsumptionUnitID: "",
      // TotalConsumptionUnitQty: "",
      // TotalAvailableConsumptionUnitQty: "",
      OneUnitEqualToConsumptionUnit: "",
      IsConsumableNotEdit: false,
      IsItemStockSerialNumberWise: false,
    },
    validateOnBlur: false,
  });

  const {
    setFieldValue,
    values: { IsConsumable, IsConsumableNotEdit, IsItemStockSerialNumberWise },
  } = formik;

  const handleValidSubmit = (values) => {
    // if (
    //   parseInt(values?.TotalAvailableUnitQty) > parseInt(values?.TotalUnitQty)
    // ) {
    //   formik.setFieldError(
    //     "TotalAvailableUnitQty",
    //     "Total Available Unit Qty must be less then or equal to Total Unit Qty..."
    //   );
    //   formik.setFieldTouched("TotalAvailableUnitQty", true);
    //   return;
    // }

    setIsLoading(true);

    let payload = {
      ...values,
      ItemName: values?.ItemName.trim(),
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    post(
      PrimaryIdParam ? POST_InventoryItemsUpdate : POST_InventoryItemsInsert,
      payload,
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/items");
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">
                {PrimaryIdParam ? "Edit" : "Add"} Items
              </h4>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Row>
                    <Col lg={3}>
                      <Field
                        label="Item Name"
                        name="ItemName"
                        placeholder={"Enter Item Name"}
                        component={CustomInput}
                        required
                        maxLength={500}
                        autoFocus
                        onChange={(e) => {
                          formik.setFieldValue(
                            "ItemName",
                            capitalizeString(e?.target?.value),
                          );
                        }}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        label="Item Code"
                        name="ItemCode"
                        placeholder={"Enter Item Code"}
                        component={CustomInput}
                        required
                        maxLength={500}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        label="Item Type"
                        name="ItemType"
                        placeholder={"Select Item Type"}
                        options={itemTypeOptions}
                        component={CustomSelect}
                        isClearable={false}
                        required
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        label="Unit"
                        name="UnitID"
                        placeholder={"Select Unit"}
                        options={unitOptions}
                        component={CustomSelect}
                        isClearable={false}
                        required
                        onChange={(e) => {
                          if (!PrimaryIdParam) {
                            formik.setFieldValue(
                              "ConsumptionUnitID",
                              e?.value ?? "",
                            );
                          }
                          formik.setFieldValue("UnitID", e?.value ?? "");
                          formik.setFieldValue(
                            "OneUnitEqualToConsumptionUnit",
                            1,
                          );
                        }}
                      />
                    </Col>
                    {/* <Col lg={3}>
                      <Field
                        type="number"
                        label={"Total Unit Qty"}
                        name="TotalUnitQty"
                        placeholder={"Enter Total Unit Qty"}
                        component={CustomInput}
                        numberTypeWithoutDot={true}
                        required
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        type="number"
                        label={"Total Available Unit Qty"}
                        name="TotalAvailableUnitQty"
                        placeholder={"Enter Total Available Unit Qty"}
                        component={CustomInput}
                        numberTypeWithoutDot={true}
                        required
                      />
                    </Col> */}

                    <Col lg={3}>
                      <label className="mb-1">
                        Item Stock Serial Number Wise
                      </label>
                      <div className="mb-2 form-control form-control-sm">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="IsItemStockSerialNumberWise"
                          name="IsItemStockSerialNumberWise"
                          checked={IsItemStockSerialNumberWise}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "IsItemStockSerialNumberWise",
                              e?.target?.checked,
                            );
                          }}
                        />
                        <label
                          className="form-check-label ms-2"
                          htmlFor="IsItemStockSerialNumberWise"
                        >
                          Item Stock Serial Number Wise
                        </label>
                      </div>
                    </Col>
                    <Col lg={3}>
                      <label className="mb-1">Consumable</label>
                      <div className="mb-2 form-control form-control-sm">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="IsConsumable"
                          name="IsConsumable"
                          checked={IsConsumable}
                          disabled={IsConsumableNotEdit}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "IsConsumable",
                              e?.target?.checked,
                            );
                          }}
                        />
                        <label
                          className="form-check-label ms-2"
                          htmlFor="IsConsumable"
                        >
                          Consumable
                        </label>
                      </div>
                    </Col>
                    {IsConsumable ? (
                      <>
                        <Col lg={3}>
                          <Field
                            label="Consumption Unit"
                            name="ConsumptionUnitID"
                            placeholder={"Select Consumption Unit"}
                            options={unitOptions}
                            component={CustomSelect}
                            isDisabled={IsConsumableNotEdit}
                            //isClearable={false}
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            type="number"
                            label={"One Unit Equal To Consumption Unit"}
                            name="OneUnitEqualToConsumptionUnit"
                            placeholder={
                              "Enter One Unit Equal To Consumption Unit"
                            }
                            component={CustomInput}
                            numberTypeWithoutDot={true}
                            disabled={IsConsumableNotEdit}
                          />
                        </Col>
                      </>
                    ) : (
                      ""
                    )}
                    <Col lg={3}>
                      <Field
                        label="Description"
                        name="Description"
                        rows={5}
                        placeholder={"Enter Description"}
                        component={CustomTextArea}
                        maxLength={1000}
                      />
                    </Col>
                  </Row>
                  <hr className="mt-1 mb-2"></hr>
                  <button type="submit" className="btn btn-primary btn-sm me-2">
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Form>
              </FormikProvider>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default AddInventoryItems;
